export default function Mission() {
  const pillars = [
    {
      icon: 'ri-group-2-line',
      title: 'Bring Families Together',
      description:
        'Connect with other families navigating CSCF. Share experiences, find understanding, and build lasting relationships with people who truly get it.',
      iconBg: 'bg-brand-100',
      iconColor: 'text-brand-600',
      accent: 'border-t-brand-500',
    },
    {
      icon: 'ri-book-open-line',
      title: 'Share Trusted Information',
      description:
        'Access reliable, up-to-date information about CSCF — from diagnosis and symptoms to treatment options and specialist resources backed by peer-reviewed research.',
      iconBg: 'bg-accent-100',
      iconColor: 'text-accent-600',
      accent: 'border-t-accent-500',
    },
    {
      icon: 'ri-microscope-line',
      title: 'Help Move Research Forward',
      description:
        'Support and participate in research efforts that bring us closer to better treatments and, ultimately, a cure for CSCF. Every story shared matters.',
      iconBg: 'bg-emerald-100',
      iconColor: 'text-emerald-600',
      accent: 'border-t-emerald-500',
    },
  ];

  return (
    <section id="mission" className="py-20 bg-white">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-block px-4 py-1.5 bg-brand-50 border border-brand-100 rounded-full mb-4">
            <span className="text-xs font-semibold text-brand-600 tracking-widest font-heading">OUR MISSION</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 font-heading">
            Why CSCF Support Exists
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto font-body leading-relaxed">
            We exist to make sure no family faces this diagnosis alone — with community, knowledge, and hope.
          </p>
        </div>

        {/* 3-column pillars */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {pillars.map((pillar, index) => (
            <div
              key={index}
              className="bg-white border border-gray-100 rounded-2xl p-8 flex flex-col hover:border-brand-200 transition-colors"
              style={{ borderTop: '3px solid' }}
            >
              <div className={`w-14 h-14 flex items-center justify-center ${pillar.iconBg} rounded-xl mb-6`}>
                <i className={`${pillar.icon} text-2xl ${pillar.iconColor}`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3 font-heading">{pillar.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed flex-grow font-body">{pillar.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
